export const FULL_DATE_TIME_FORMAT = 'dd MMM yyyy HH:mm a';
export const SERVER_DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_FORMAT = 'dd MMM yyyy';
export const TIME_FORMAT = 'HH:mm';
export const KYC_DATE_FORMAT = 'MM/dd/yyyy';
export const MIN_AGE = 18;
